import Navbar from './Navbar';

const More = () => {
    return (
        <div>
            <Navbar />
            <div className='container pt-5'>
                <h1 className='text-center'>More to come!</h1>
            </div>
        </div>
    );
};

export default More;